import {Component, OnInit} from "@angular/core";
import { CommunicationService } from "../../services/communication.service";
import { AttachMeta } from "../../../../core/models/attach.model";
import { applicationTypes, CommunicationContent, ConversationApplicationRequest, ConversationApplicationsResponse, inquiryTopics, NewMessage } from "../../models/communications.model";
import { MessageHelper } from "../../../../core/helpers/message-helper";
import { CompanyType } from "../../../../core/constants/company-type.enum";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
    selector: 'app-communication-submit-request',
    templateUrl: './communication-submit-request.component.html',
    styleUrl: './communication-submit-request.component.scss',
    standalone: false
})
export class CommunicationSubmitRequestComponent implements OnInit {
  selectedApplicationTypeId: any;
  selectedApplicationId: any;
  inputMessageValue: any;
  fileList: File[] = [];
  uploadedDocs: AttachMeta[] = [];
  acceptTypes = '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png';
  //@ts-ignore
  applications: ConversationApplication[];
  request: ConversationApplicationRequest = new ConversationApplicationRequest();
  //@ts-ignore
  response: ConversationApplicationsResponse;
  newMessage: NewMessage = new NewMessage();
  isLoading: boolean = false;

  protected readonly inquiryTopics = inquiryTopics;
  protected readonly applicationTypes = applicationTypes;

  constructor(private communicationSrsService: CommunicationService, private messageService: NzMessageService
  ) {
  }

  ngOnInit(): void {
  }



  onPageChange(event: any) {
    this.request.pageNumber = event-1;
    this.loadApplications();
  }

  onPageSizeChange(event: any) {
    this.request.pageSize = event;
    this.loadApplications();
  }

  loadApplications() {
    this.communicationSrsService.getApplicationList(this.request).subscribe((resp: ConversationApplicationsResponse) => {
      console.warn(resp);
      this.response = resp;
      this.request.pageNumber = resp.number;
      this.request.pageSize = resp.size;
      this.applications = resp.content;
    })

  }

  onBack() {
    this.communicationSrsService.communicationContent = CommunicationContent.MAIN_REQUESTS;
  }

  onCancel() {
    this.communicationSrsService.communicationContent = CommunicationContent.MAIN_REQUESTS;
  }


  onChooseType(type: any) {
    this.selectedApplicationTypeId = type.id;
    this.request.applicationType = this.selectedApplicationTypeId == 1 ? "REGISTRATION" : "POST_REGISTRATION";
    // this.request.applicationTypeId = [this.selectedApplicationTypeId];
    this.loadApplications();
  }

  onChooseApplication(application: any) {
    this.communicationSrsService.getMessagesByChat(application.applicationId)
      .subscribe(resp => {
        this.selectedApplicationId = application.applicationId;
        if (resp != null) {
          this.communicationSrsService.selectedRequestChat = resp;
          this.communicationSrsService.communicationContent = CommunicationContent.REQUEST_CHAT;
        }
        else {
          this.newMessage.applicationId = application.applicationId;
        }
      })
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const incoming = Array.from(input.files);

    const canTake = Math.max(0, 5 - this.fileList.length);
    const toAdd = incoming.filter(f => this.validateFile(f)).slice(0, canTake);

    if (!toAdd.length) {
      input.value = '';
      return;
    }

    this.fileList.push(...toAdd);

    this.communicationSrsService.uploadDocuments(toAdd).subscribe({
      next: (docs) => {
        this.uploadedDocs.push(...docs);

        this.newMessage.documentIds = this.uploadedDocs.map(d => d.id);

        const ids = this.uploadedDocs.map(d => d.id);
      },
      error: (err) => {
        console.error('Ошибка загрузки файлов:', err);
      }
    });

    input.value = '';
  }

  onPreview(file: File): void {
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  removeFile(index: number): void {
    const removed = this.fileList.splice(index, 1)[0];

    const docIdx = this.uploadedDocs.findIndex(d => d.fileName === removed.name);
    if (docIdx > -1) {
      this.uploadedDocs.splice(docIdx, 1);
      this.newMessage.documentIds = this.uploadedDocs.map(d => d.id);
    }
  }

  validateFile(file: File): boolean {
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'image/jpeg',
      'image/png'
    ];

    if (!allowedTypes.includes(file.type)) {
      console.error('Недопустимый тип файла:', file.type);
      return false;
    }

    if (file.size / 1024 / 1024 > 5) {
      console.error('Файл слишком большой:', file.name);
      return false;
    }

    return true;
  }

  get page(): number {
    return this.request.pageNumber!+1;
  }

  get size(): number {
    return this.request.pageSize!;
  }

  get total(): number {
    return this.response.totalElements;
  }

  getCompanyTypeText(type: CompanyType): string {
    return MessageHelper.getCompanyTypeText(type)!;
  }

  onSendMessage() {
    if (this.newMessage.content == null || this.newMessage.content.trim() === '') {
      return;
    }
    if (this.newMessage.content != null && this.newMessage.content.length >= 200) {
      this.messageService.error('The message exceeds the 200 character limit.');
      return;
    }
    this.isLoading = true;
    this.newMessage.documentIds = this.uploadedDocs.map(d => d.id);
    this.communicationSrsService.sendMessage(this.newMessage).subscribe({
      next: (resp) => {
        this.isLoading = false;
        this.onBack();
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Ошибка отправки сообщения:', err);
      }
    })
  }
}
